export default {
  getBlocks : (state) => { return state.blocks; },
}
